<template>
  <div class="app-container">
    <h3 class="centre">Payment processed, redirecting to order detail...</h3>
  </div>
</template>

<script>
import logger from "@/utils/logger";

const name = "PaymentOmipayResult";
const log = logger(name);

export default {
  data() {
    return {
      result: ""
    };
  },
  created() {
    const query = this.$route.query;
    log.info("Payment result", query);
    if (query.internalOrderId) {
      setTimeout(
        () =>
          this.$router.push(
            `/order/${query.internalOrderId}?isFromPaymentResult=true`
          ),
        3000
      );
    }
  },
  methods: {}
};
</script>

<style scoped lang="scss">
</style>